import React, { lazy } from 'react';
import { Wallet3Line } from '@datanomik/commons-ui/icons';

const TariffsMainPage = lazy(() =>
  import('./TariffsMainPage').then((m) => ({ default: m.TariffsMainPage })),
);

export const getTariffsRoutes = () => [
  {
    path: '',
    key: 'tariffs',
    label: 'Tarifas',
    description: 'Auditoria de tarifas bancárias.',
    element: <TariffsMainPage />,
    icon: <Wallet3Line />,
  },
];
